import React, { Fragment, memo } from 'react'
import PropTypes from 'prop-types'
import { Portal } from 'react-portal'
import Tooltip from 'react-tooltip'
import { useMedia, useUniqueId } from 'sb-hooks'
import cx from 'classnames'
import { intlMessageShape } from 'sb-react-intl'

import Message from 'components/text/Message/Message'

import s from './HelpIconWithTooltip.scss'


const mobileToolipProps = {
  place: 'bottom',
  event: 'click',
  globalEventOff: 'click',
  multiline: true,
}

// TODO @ivashev continue investigate id issue
const HelpIconWithTooltip = ({ className, message, id }) => {
  const { isMobile }      = useMedia()
  const buttonClassName   = cx(className, s.helpButton)

  return (
    <Fragment>
      <button
        className={buttonClassName}
        type="button"
        data-tip
        data-for={id}
        aria-labelledby={id}
      />
      <Portal>
        <Tooltip
          id={id}
          className={s.note}
          place="right"
          type="light"
          effect="solid"
          border
          {...(isMobile ? mobileToolipProps : {})}
        >
          <Message text={message} html />
        </Tooltip>
      </Portal>
    </Fragment>
  )
}

HelpIconWithTooltip.propTypes = {
  className: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.shape(intlMessageShape),
    PropTypes.string,
  ]).isRequired,
}


export default memo(HelpIconWithTooltip)
